import { combineReducers } from "redux";
import schema from "./schema/reducers";
import codebook from "./codebook/reducers";
import api from "./api/reducers";
import ids from "./ids/reducers";
import cache from "./cache/reducers";
import loading from "./loading/reducers";
import notifications from "./notifications/reducers";
import apicallsprogress from "./apicallsprogress/reducers";
import errorAlert from "./errorAlert/reducers";

const services = combineReducers({
  schema,
  codebook,
  api,
  ids,
  cache,
  loading,
  notifications,
  errorAlert,
  apicallsprogress,
});

export default services;
